import * as React from "react";
import { ListItem } from "../../list/list-item/list-item.mjs";
const NotificationListItem = (props) => {
  const { className, children } = props;
  const BEM = () => {
    const classArray = ["notification-list__item"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement(ListItem, { className: BEM() }, children);
};
export {
  NotificationListItem
};
